module.exports = __webpack_public_path__ + "static/media/tip_text_cat_tick_fr.97060001.svg";